/**
 * @generated SignedSource<<09c56e21095ef5f4ab37f364e749339e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type videoSectionPageQuery$variables = {
  after?: string | null | undefined;
  count?: number | null | undefined;
  entityId: string;
  sectionIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  videoLatestQueueName: string;
  videoShortQueueName: string;
};
export type videoSectionPageQuery$data = {
  readonly videoSection: {
    readonly advertZone: string | null | undefined;
    readonly entityId: string;
    readonly images: ReadonlyArray<{
      readonly height: number | null | undefined;
      readonly url: string;
      readonly width: number | null | undefined;
    } | null | undefined> | null | undefined;
    readonly name: string;
    readonly urlAlias: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"latestVideoQuery" | "videoHeaderDropdownMenuQuery" | "videoListQuery" | "videoShortCarousel">;
};
export type videoSectionPageQuery = {
  response: videoSectionPageQuery$data;
  variables: videoSectionPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 24,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sectionIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "videoLatestQueueName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "videoShortQueueName"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityId",
        "variableName": "entityId"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "version",
      "value": 2
    }
  ],
  "kind": "ScalarField",
  "name": "advertZone",
  "storageKey": "advertZone(version:2)"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "height",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "width",
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v9 = {
  "kind": "Variable",
  "name": "sectionIds",
  "variableName": "sectionIds"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v13 = {
  "kind": "InlineFragment",
  "selections": (v12/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v10/*: any*/)
  ],
  "storageKey": null
},
v16 = [
  (v2/*: any*/),
  (v10/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v16/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentSection",
      "storageKey": null
    }
  ],
  "type": "Section",
  "abstractKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flattenTypeIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LiveArticle",
      "kind": "LinkedField",
      "name": "liveArticle",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        (v10/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
},
v20 = [
  (v2/*: any*/)
],
v21 = {
  "kind": "InlineFragment",
  "selections": (v20/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v23 = {
  "kind": "InlineFragment",
  "selections": (v20/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    (v24/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v26 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            (v11/*: any*/),
            (v21/*: any*/),
            (v22/*: any*/),
            (v23/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v25/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v27 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    (v14/*: any*/),
    (v4/*: any*/),
    (v15/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v26/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v28 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 20
      }
    ],
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QueueItemsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v13/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v12/*: any*/),
                "type": "Topic",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v12/*: any*/),
                "type": "VideoSection",
                "abstractKey": null
              },
              (v27/*: any*/),
              (v22/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "items(first:20)"
  },
  (v10/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "VideoSource",
  "kind": "LinkedField",
  "name": "videoSource",
  "plural": true,
  "selections": [
    (v10/*: any*/),
    (v29/*: any*/)
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v32 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "type": "MAIN_IMAGE"
    }
  }
],
v33 = [
  (v6/*: any*/)
],
v34 = {
  "alias": "size220x137",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "220x137"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v33/*: any*/),
  "storageKey": "style(filter:{\"style\":\"220x137\"})"
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v37 = [
  (v3/*: any*/)
],
v38 = {
  "kind": "InlineFragment",
  "selections": (v37/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortUrl",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleSpeech",
  "kind": "LinkedField",
  "name": "articleSpeeches",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "country",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gender",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voiceName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSlideshow",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v42/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v16/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Sponsor",
      "kind": "LinkedField",
      "name": "sponsor",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v29/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "images",
          "plural": true,
          "selections": (v33/*: any*/),
          "storageKey": null
        },
        (v10/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v49 = {
  "kind": "InlineFragment",
  "selections": [
    (v47/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v48/*: any*/)
      ],
      "type": "Article",
      "abstractKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v50 = [
  (v3/*: any*/),
  (v10/*: any*/)
],
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "published",
  "storageKey": null
},
v52 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    (v4/*: any*/),
    (v15/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v26/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v53 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }
],
v54 = [
  (v8/*: any*/),
  {
    "kind": "Literal",
    "name": "contentTypes",
    "value": [
      "VIDEO"
    ]
  },
  {
    "fields": [
      (v9/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "DESC",
      "field": "PUBLISHED_DATE"
    }
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "videoSectionPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VideoSection",
        "kind": "LinkedField",
        "name": "videoSection",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      {
        "args": [
          {
            "kind": "Literal",
            "name": "withHighlight",
            "value": false
          }
        ],
        "kind": "FragmentSpread",
        "name": "videoHeaderDropdownMenuQuery"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "videoLatestQueueName",
            "variableName": "videoLatestQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "latestVideoQuery"
      },
      {
        "args": [
          (v8/*: any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          (v9/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "videoListQuery"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "queueName",
            "variableName": "videoShortQueueName"
          }
        ],
        "kind": "FragmentSpread",
        "name": "videoShortCarousel"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "videoSectionPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VideoSection",
        "kind": "LinkedField",
        "name": "videoSection",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v7/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "videoSeriesMenu",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "name": "video_series_menu"
            }
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v28/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"video_series_menu\"})"
      },
      {
        "alias": "videoSectionMenu",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": {
              "name": "video_sections_menu"
            }
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v28/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"video_sections_menu\"})"
      },
      {
        "alias": "videoTop",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "videoLatestQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 29
              }
            ],
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": "latestVideoYoutubeId",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "youtubeId",
                            "storageKey": null
                          },
                          (v30/*: any*/),
                          (v31/*: any*/),
                          {
                            "alias": null,
                            "args": (v32/*: any*/),
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "image",
                            "plural": false,
                            "selections": [
                              (v34/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "wide_landscape"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v33/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
                              }
                            ],
                            "storageKey": "image(filter:{\"type\":\"MAIN_IMAGE\"})"
                          },
                          (v35/*: any*/),
                          (v36/*: any*/),
                          {
                            "alias": "videoPrimaryYoutubeId",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "youtubeId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SectionSegmentV2",
                            "kind": "LinkedField",
                            "name": "sectionsV2",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": [
                                  (v11/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isSectionUnion"
                                  },
                                  (v38/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v37/*: any*/),
                                    "type": "Section",
                                    "abstractKey": null
                                  },
                                  (v27/*: any*/),
                                  (v22/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Topic",
                            "kind": "LinkedField",
                            "name": "topics",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "shortName",
                                "storageKey": null
                              },
                              (v10/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v11/*: any*/),
                                  (v2/*: any*/),
                                  (v14/*: any*/),
                                  (v4/*: any*/),
                                  (v15/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v26/*: any*/)
                                ],
                                "type": "BaseWithApplicationAndUrlAlias",
                                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v14/*: any*/),
                              (v4/*: any*/),
                              (v15/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SectionSegmentV2",
                                    "kind": "LinkedField",
                                    "name": "sectionsV2",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          (v21/*: any*/),
                                          (v23/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v25/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "BaseWithApplicationAndUrlAlias",
                            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/),
                              (v39/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v43/*: any*/),
                                  (v44/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SectionSegmentV2",
                                    "kind": "LinkedField",
                                    "name": "sectionsV2",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          (v21/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v45/*: any*/),
                                  (v46/*: any*/),
                                  (v49/*: any*/)
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          }
                        ],
                        "type": "Video",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v31/*: any*/),
                              (v36/*: any*/),
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v39/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SectionSegmentV2",
                                "kind": "LinkedField",
                                "name": "sectionsV2",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v13/*: any*/),
                                      (v23/*: any*/),
                                      (v22/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Topic",
                                "kind": "LinkedField",
                                "name": "topics",
                                "plural": true,
                                "selections": (v50/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "publishedDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Author",
                                "kind": "LinkedField",
                                "name": "authors",
                                "plural": true,
                                "selections": (v50/*: any*/),
                                "storageKey": null
                              },
                              (v14/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleTypeSegment",
                                    "kind": "LinkedField",
                                    "name": "types",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ArticleType",
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v10/*: any*/),
                                          (v3/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SectionSegmentV2",
                                    "kind": "LinkedField",
                                    "name": "sectionsV2",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v51/*: any*/),
                                              (v52/*: any*/)
                                            ],
                                            "type": "Section",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "disableOffPlatformContent",
                                    "storageKey": null
                                  },
                                  (v48/*: any*/),
                                  (v51/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Author",
                                    "kind": "LinkedField",
                                    "name": "authors",
                                    "plural": true,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v11/*: any*/),
                                          (v14/*: any*/),
                                          (v4/*: any*/),
                                          (v15/*: any*/),
                                          (v17/*: any*/),
                                          (v18/*: any*/),
                                          (v19/*: any*/),
                                          (v26/*: any*/)
                                        ],
                                        "type": "BaseWithApplicationAndUrlAlias",
                                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "images",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": "generic_og",
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                              "style": "og_image_scmp_generic"
                                            }
                                          }
                                        ],
                                        "concreteType": "ImageStyle",
                                        "kind": "LinkedField",
                                        "name": "style",
                                        "plural": false,
                                        "selections": (v33/*: any*/),
                                        "storageKey": "style(filter:{\"style\":\"og_image_scmp_generic\"})"
                                      },
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                              "styles": [
                                                "og_postmag",
                                                "og_image_style",
                                                "og_image_scmp_analysis",
                                                "og_image_scmp_explainer",
                                                "og_image_scmp_editorial",
                                                "og_image_scmp_fact_check",
                                                "og_image_scmp_debate",
                                                "og_image_scmp_live",
                                                "og_image_scmp_obituary",
                                                "og_image_scmp_opinion",
                                                "og_image_scmp_review",
                                                "og_image_scmp_series",
                                                "og_image_scmp_generic"
                                              ]
                                            }
                                          }
                                        ],
                                        "concreteType": "ImageStyle",
                                        "kind": "LinkedField",
                                        "name": "styles",
                                        "plural": true,
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "style",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "styles(filter:{\"styles\":[\"og_postmag\",\"og_image_style\",\"og_image_scmp_analysis\",\"og_image_scmp_explainer\",\"og_image_scmp_editorial\",\"og_image_scmp_fact_check\",\"og_image_scmp_debate\",\"og_image_scmp_live\",\"og_image_scmp_obituary\",\"og_image_scmp_opinion\",\"og_image_scmp_review\",\"og_image_scmp_series\",\"og_image_scmp_generic\"]})"
                                      },
                                      (v29/*: any*/),
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                              "style": "768x768"
                                            }
                                          }
                                        ],
                                        "concreteType": "ImageStyle",
                                        "kind": "LinkedField",
                                        "name": "style",
                                        "plural": false,
                                        "selections": (v33/*: any*/),
                                        "storageKey": "style(filter:{\"style\":\"768x768\"})"
                                      },
                                      (v42/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "updatedDate",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FormattedValue",
                                    "kind": "LinkedField",
                                    "name": "summary",
                                    "plural": false,
                                    "selections": (v53/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FormattedValue",
                                    "kind": "LinkedField",
                                    "name": "subHeadline",
                                    "plural": false,
                                    "selections": (v53/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "customContents",
                                        "value": []
                                      },
                                      {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "PARAGRAPH"
                                      }
                                    ],
                                    "concreteType": "FormattedValue",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": (v53/*: any*/),
                                    "storageKey": "body(customContents:[],type:\"PARAGRAPH\")"
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "keywords",
                                    "storageKey": null
                                  },
                                  (v46/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "readingTime",
                                    "storageKey": null
                                  },
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v44/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sentiment",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Topic",
                                    "kind": "LinkedField",
                                    "name": "firstTopic",
                                    "plural": false,
                                    "selections": (v50/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SectionSegmentV2",
                                        "kind": "LinkedField",
                                        "name": "sectionsV2",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "value",
                                            "plural": true,
                                            "selections": [
                                              (v38/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v47/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ArticleTypeSegment",
                                            "kind": "LinkedField",
                                            "name": "types",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ArticleType",
                                                "kind": "LinkedField",
                                                "name": "value",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "FormattedValue",
                                                    "kind": "LinkedField",
                                                    "name": "description",
                                                    "plural": false,
                                                    "selections": (v53/*: any*/),
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Author",
                                            "kind": "LinkedField",
                                            "name": "authors",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "types",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v24/*: any*/)
                                        ],
                                        "type": "Article",
                                        "abstractKey": null
                                      }
                                    ],
                                    "type": "Content",
                                    "abstractKey": "__isContent"
                                  }
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SectionSegmentV2",
                                "kind": "LinkedField",
                                "name": "sectionsV2",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v13/*: any*/),
                                      (v22/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Section",
                                "kind": "LinkedField",
                                "name": "fullSectionPath",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  (v3/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Section",
                            "abstractKey": null
                          }
                        ],
                        "type": "BaseWithApplicationAndUrlAlias",
                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                      },
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:29)"
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v54/*: any*/),
        "concreteType": "ContentConnection",
        "kind": "LinkedField",
        "name": "contents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v31/*: any*/),
                      {
                        "alias": null,
                        "args": (v32/*: any*/),
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": [
                          (v34/*: any*/)
                        ],
                        "storageKey": "image(filter:{\"type\":\"MAIN_IMAGE\"})"
                      },
                      (v35/*: any*/),
                      (v52/*: any*/)
                    ],
                    "type": "Video",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v54/*: any*/),
        "filters": [
          "filter",
          "contentTypes",
          "orderBy"
        ],
        "handle": "connection",
        "key": "allVideos_contents",
        "kind": "LinkedHandle",
        "name": "contents"
      },
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "videoShortQueueName"
              }
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 10
              }
            ],
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/),
                          (v31/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "youtubeId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              {
                                "alias": "portraitStyle",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "portrait"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v33/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"portrait\"})"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "Video",
                        "abstractKey": null
                      },
                      (v22/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          (v39/*: any*/),
                          (v31/*: any*/),
                          (v36/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v30/*: any*/)
                            ],
                            "type": "Video",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v40/*: any*/),
                              (v41/*: any*/),
                              (v43/*: any*/),
                              (v44/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SectionSegmentV2",
                                "kind": "LinkedField",
                                "name": "sectionsV2",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v21/*: any*/),
                                      (v22/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v45/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Topic",
                                "kind": "LinkedField",
                                "name": "topics",
                                "plural": true,
                                "selections": (v16/*: any*/),
                                "storageKey": null
                              },
                              (v49/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v26/*: any*/)
                            ],
                            "type": "BaseWithApplicationAndUrlAlias",
                            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:10)"
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2d96bf0a941c33a84e5e209653476d9d",
    "id": null,
    "metadata": {},
    "name": "videoSectionPageQuery",
    "operationKind": "query",
    "text": "query videoSectionPageQuery(\n  $after: String\n  $count: Int = 24\n  $entityId: String!\n  $sectionIds: [String]\n  $videoLatestQueueName: String!\n  $videoShortQueueName: String!\n) {\n  videoSection(filter: {entityId: $entityId}) {\n    entityId\n    name\n    urlAlias\n    advertZone(version: 2)\n    images {\n      height\n      width\n      url\n    }\n    id\n  }\n  ...videoHeaderDropdownMenuQuery_4eBY9P\n  ...latestVideoQuery_29kcpA\n  ...videoListQuery_1vC9Q5\n  ...videoShortCarousel_1ET35F\n}\n\nfragment abandonedCartOfferDialogArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  topics {\n    name\n    id\n  }\n}\n\nfragment actionWidgetContent on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  ... on Article {\n    ...articleCommentsTriggerArticle\n    ...articlePrintArticle\n  }\n  ...copyLinkArticle20CopyLinkContent\n  ...entityLink\n}\n\nfragment articleCommentsTriggerArticle on Article {\n  commentCount\n  entityId\n  ...helpersUseContentSponsorContent\n}\n\nfragment articleHeadlineHeaderFeaturesContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n}\n\nfragment articlePrintArticle on Article {\n  ...contentShareWidgetContent\n}\n\nfragment articleSeoArticle_3boCng on Article {\n  ...hooksArticleSeoArticle\n  ...helpersGetArticleTypeArticle\n  entityId\n  publishedDate\n  updatedDate\n  summary {\n    text\n  }\n  subHeadline {\n    text\n  }\n  body(customContents: [], type: PARAGRAPH) {\n    text\n  }\n  keywords\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  topics {\n    name\n    entityId\n    id\n  }\n  urlAlias\n  authors {\n    name\n    id\n  }\n  images {\n    style(filter: {style: \"768x768\"}) {\n      url\n    }\n  }\n  readingTime\n}\n\nfragment articleShareWidgetArticle on Article {\n  ...contentShareWidgetContent\n  ...articleCommentsTriggerArticle\n  ...articleSpeechInlineWidgetArticle\n}\n\nfragment articleSpeechInlineWidgetArticle on Article {\n  articleSpeeches {\n    url\n  }\n  ...genericArticleSpeechInlineWidgetGenericArticle\n}\n\nfragment atomsCurrentArticleAtomBase_3boCng on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Content {\n    __isContent: __typename\n    ...articleHeadlineHeaderFeaturesContent\n    ...articleSeoArticle_3boCng\n    ...articleShareWidgetArticle\n    ...bookmarkHeaderFeaturesContent\n    ...commentHeaderFeaturesArticle\n    ...contentShareWidgetContent\n    ...helpersCheckIsStyleArticle\n    ...helpersUseSharingUrl\n    ...hooksContentInterestArticle\n    ...hooksTrackPageViewArticle\n    ...hooksUseCurrentArticleIdsArticle\n    ...hooksUseCurrentArticlePrebidConfigArticle\n    ...hooksUsePageTargetingArticle\n    ...onboardingNewsletterSubscriptionArticle\n    ...entityLinkHeaderFeaturesArticle\n    ...shareHeaderFeaturesContent\n    ...abandonedCartOfferDialogArticle\n  }\n}\n\nfragment atomsCurrentShareContentAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    ...contentShareWidgetContent\n  }\n  ... on Video {\n    ...contentShareWidgetContent\n  }\n}\n\nfragment atomsCurrentStyleCardCarouselWidgetSectionsAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    sectionsV2 {\n      value {\n        __typename\n        ... on Section {\n          entityId\n          name\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      name\n      id\n    }\n  }\n}\n\nfragment atomsCurrentTakeoverAdSectionsAtomBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Article {\n    sectionsV2 {\n      value {\n        __typename\n        ... on Section {\n          entityId\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n  }\n}\n\nfragment bookmarkHeaderFeaturesContent on Content {\n  __isContent: __typename\n  entityId\n}\n\nfragment buttonArticleSpeechInlineWidgetGenericButtonArticle on Article {\n  entityId\n  socialHeadline\n  headline\n  articleSpeeches {\n    country\n    gender\n    url\n    voiceName\n  }\n  images {\n    isSlideshow\n    url\n  }\n}\n\nfragment commentHeaderFeaturesArticle on Article {\n  ...articleCommentsTriggerArticle\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n}\n\nfragment copyLinkArticle20CopyLinkContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  shortUrl\n  headline\n  socialHeadline\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment entityLinkHeaderFeaturesArticle on Article {\n  authors {\n    name\n    ...entityLink\n    id\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n        published\n        ...entityLink\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment genericArticleSpeechInlineWidgetGenericArticle on Article {\n  entityId\n  articleSpeeches {\n    url\n  }\n  ...buttonArticleSpeechInlineWidgetGenericButtonArticle\n  ...hooksShowGenericInlineWidgetByArticleArticle\n  ...toolTipArticleSpeechWidgetToolTipArticle\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on SectionUnion {\n  __isSectionUnion: __typename\n  ... on Section {\n    name\n  }\n  ... on VideoSection {\n    name\n  }\n}\n\nfragment helpersCheckIsAmpEnabledArticle on Article {\n  entityId\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  disableOffPlatformContent\n  sponsorType\n  published\n  ...helpersCheckIsPlusArticle\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment helpersUseSharingUrl on Content {\n  __isContent: __typename\n  urlAlias\n}\n\nfragment hooksArticleSeoArticle on Article {\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...hooksContentHeadlineTagContent\n  ...helpersCheckIsAmpEnabledArticle\n  entityId\n  headline\n  socialHeadline\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  authors {\n    entityId\n    id\n  }\n  images {\n    generic_og: style(filter: {style: \"og_image_scmp_generic\"}) {\n      url\n    }\n    styles(filter: {styles: [\"og_postmag\", \"og_image_style\", \"og_image_scmp_analysis\", \"og_image_scmp_explainer\", \"og_image_scmp_editorial\", \"og_image_scmp_fact_check\", \"og_image_scmp_debate\", \"og_image_scmp_live\", \"og_image_scmp_obituary\", \"og_image_scmp_opinion\", \"og_image_scmp_review\", \"og_image_scmp_series\", \"og_image_scmp_generic\"]}) {\n      url\n      style\n    }\n    type\n  }\n  urlAlias\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentInterestArticle on Content {\n  __isContent: __typename\n  __typename\n  entityId\n  urlAlias\n  topics {\n    name\n    id\n  }\n  ... on Article {\n    sentiment\n    types {\n      value {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment hooksPaywallPromiseContent on Content {\n  __isContent: __typename\n  entityId\n}\n\nfragment hooksShowGenericInlineWidgetByArticleArticle on Article {\n  ...hooksPaywallPromiseContent\n  entityId\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hooksTrackCurrentItemBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ...atomsCurrentArticleAtomBase_3boCng\n  ...atomsCurrentShareContentAtomBase\n  ...atomsCurrentStyleCardCarouselWidgetSectionsAtomBase\n  ...atomsCurrentTakeoverAdSectionsAtomBase\n}\n\nfragment hooksTrackPageViewArticle on Content {\n  __isContent: __typename\n  entityId\n  publishedDate\n  headline\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  urlAlias\n  authors {\n    name\n    id\n  }\n  entityUuid\n}\n\nfragment hooksUseCurrentArticleIdsArticle on Content {\n  __isContent: __typename\n  entityId\n  entityUuid\n}\n\nfragment hooksUseCurrentArticlePrebidConfigArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  topics {\n    name\n    id\n  }\n}\n\nfragment hooksUsePageTargetingArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  firstTopic {\n    name\n    id\n  }\n}\n\nfragment itemVideoUpNextWidgetItemVideo on Video {\n  entityId\n  duration\n  headline\n  socialHeadline\n  image(filter: {type: MAIN_IMAGE}) {\n    style(filter: {style: \"wide_landscape\"}) {\n      url\n    }\n  }\n}\n\nfragment latestVideoQuery_29kcpA on Query {\n  videoTop: queue(filter: {name: $videoLatestQueueName}) {\n    items(first: 29) {\n      edges {\n        node {\n          __typename\n          ... on Video {\n            entityId\n            latestVideoYoutubeId: youtubeId\n            videoSource {\n              id\n              type\n            }\n            ...videoListGridCardContent\n            ...videoPrimaryContent\n          }\n          ...hooksTrackCurrentItemBase\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...videoUpNextWidgetVideo\n      }\n    }\n    id\n  }\n}\n\nfragment onboardingNewsletterSubscriptionArticle on Article {\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment popupArticle20ShareMenuContent on Content {\n  __isContent: __typename\n  ...articleShareWidgetArticle\n}\n\nfragment shareArticle20Content on Content {\n  __isContent: __typename\n  ...popupArticle20ShareMenuContent\n}\n\nfragment shareHeaderFeaturesContent on Content {\n  __isContent: __typename\n  ...shareArticle20Content\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment toolTipArticleSpeechWidgetToolTipArticle on Article {\n  entityId\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n\nfragment videoHeaderDropdownMenuQuery_4eBY9P on Query {\n  videoSeriesMenu: queue(filter: {name: \"video_series_menu\"}) {\n    items(first: 20) {\n      edges {\n        node {\n          __typename\n          ... on Section {\n            entityId\n            name\n          }\n          ... on Topic {\n            entityId\n            name\n          }\n          ... on VideoSection {\n            entityId\n            name\n          }\n          ...entityLink\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  videoSectionMenu: queue(filter: {name: \"video_sections_menu\"}) {\n    items(first: 20) {\n      edges {\n        node {\n          __typename\n          ... on Section {\n            entityId\n            name\n          }\n          ... on Topic {\n            entityId\n            name\n          }\n          ... on VideoSection {\n            entityId\n            name\n          }\n          ...entityLink\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment videoListGridCardContent on Video {\n  headline\n  image(filter: {type: MAIN_IMAGE}) {\n    size220x137: style(filter: {style: \"220x137\"}) {\n      url\n    }\n  }\n  duration\n  ...entityLink\n}\n\nfragment videoListGridQuery_1vC9Q5 on Query {\n  contents(after: $after, first: $count, filter: {sectionIds: $sectionIds}, contentTypes: [VIDEO], orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        __typename\n        ... on Video {\n          entityId\n          ...videoListGridCardContent\n        }\n        id\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment videoListQuery_1vC9Q5 on Query {\n  ...videoListGridQuery_1vC9Q5\n}\n\nfragment videoPrimaryContent on Video {\n  entityId\n  headline\n  socialHeadline\n  videoPrimaryYoutubeId: youtubeId\n  image(filter: {type: MAIN_IMAGE}) {\n    style(filter: {style: \"wide_landscape\"}) {\n      url\n    }\n  }\n  sectionsV2 {\n    value {\n      __typename\n      ... on VideoSection {\n        name\n      }\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  topics {\n    ...topicLinkTopic\n    id\n  }\n  videoSource {\n    id\n    type\n  }\n  ...actionWidgetContent\n  ...entityLink\n  ...shareArticle20Content\n}\n\nfragment videoShortCarouselCard on Video {\n  entityId\n  headline\n  youtubeId\n  images {\n    portraitStyle: style(filter: {style: \"portrait\"}) {\n      url\n    }\n  }\n}\n\nfragment videoShortCarouselPlayerContent on Content {\n  __isContent: __typename\n  ... on Video {\n    entityId\n    headline\n    youtubeId\n    videoSource {\n      id\n      type\n    }\n  }\n  ...actionWidgetContent\n  ...entityLink\n  ...shareArticle20Content\n}\n\nfragment videoShortCarouselPlayerModal on QueueItemsEdge {\n  node {\n    __typename\n    ... on Video {\n      entityId\n    }\n    ...videoShortCarouselPlayerContent\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment videoShortCarousel_1ET35F on Query {\n  queue(filter: {name: $videoShortQueueName}) {\n    items(first: 10) {\n      edges {\n        node {\n          __typename\n          ...videoShortCarouselCard\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...videoShortCarouselPlayerModal\n      }\n    }\n    id\n  }\n}\n\nfragment videoUpNextWidgetVideo on QueueItemsEdge {\n  node {\n    __typename\n    ... on Video {\n      entityId\n      ...itemVideoUpNextWidgetItemVideo\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8e0a5222e5cd4a6c75a11a8a1deb139a";

export default node;
